/* shah */
import React from 'react'

const DropSilhouetteIcon = () => {
    return (
        <svg id="SmallBoxSVG-silhouette" version="1.0" xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512.000000 512.000000"
            preserveAspectRatio="xMidYMid meet">

            <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
            >
                <path d="M2500 5113 c-27 -10 -51 -36 -150 -158 -324 -402 -705 -954 -960
-1390 -114 -195 -308 -575 -379 -745 -192 -457 -271 -840 -242 -1169 40 -441
215 -822 517 -1125 345 -344 785 -526 1274 -526 410 0 763 119 1090 366 531
401 794 1071 680 1731 -51 297 -153 592 -335 970 -196 406 -423 785 -747 1246
-224 319 -534 726 -597 781 -22 20 -119 32 -151 19z m-999 -2822 c22 -18 23
-24 20 -134 -8 -369 135 -710 408 -970 143 -136 338 -255 521 -318 66 -24 200
-55 295 -69 71 -11 89 -20 106 -51 13 -25 -7 -65 -40 -78 -76 -30 -207 -43
-371 -38 -218 7 -338 37 -521 126 -296 146 -516 402 -603 704 -66 226 -52 445
46 727 40 116 82 147 139 101z"/>
            </g>
        </svg>
    )
}

export default DropSilhouetteIcon